import PageMain from '@/components/page-main';
import { useReducer } from 'react';
import useFetch from '@/hooks/useFetch';
import fetchValueReducer from '@/hooks/fetchValueReducer';
import { Table, Tag } from 'antd';

const Index: React.FC = () => {
  const [fetchValue, dispatchFetchValue] = useReducer(fetchValueReducer, { page: 1, size: 10, total: 1 });

  const { data, loading, fetchData } = useFetch("/local/job", { ...fetchValue }, dispatchFetchValue);
  return <PageMain>
    <Table
      dataSource={data}
      columns={[
        { title: 'ID', dataIndex: 'id', key: 'id' },
        { title: '名称', dataIndex: 'name', key: 'name' },
        {
          title: '状态', dataIndex: 'status', key: 'status', render: _ => {
            const colorMap: any = {
              "PROCESSING": "yellow",
              "COMPLETED": "green",
              "FAILED": "red"
            }
            return <Tag color={colorMap[_]}>{_}</Tag>
          }
        },
        { title: '类型', dataIndex: 'category', key: 'category' },
        { title: '操作者', render: _ => _.userName + "-" + _.userid },
        { title: '更新时间', dataIndex: 'updatedAt', key: 'updatedAt' },
        { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
      ]}
      loading={loading}
      rowKey="id"
      pagination={{
        showSizeChanger: true,
        current: fetchValue.page,
        total: fetchValue.total,
        pageSize: fetchValue.size,
        pageSizeOptions: [10, 20, 50],
        onChange: (page, size) => {
          dispatchFetchValue({ type: 'update', value: { page, size } });
          fetchData();
        },
      }}
    />
  </PageMain>
}

export default Index;